export { default } from './DownloadMaterialButton';



// WEBPACK FOOTER //
// ./src/components/DownloadMaterialButton/index.js